import { Button, type ButtonProps, type StyleProps } from '@chakra-ui/react'
import { usePathname } from 'next/navigation'

import { getVerifyUrl } from '@/client/services/url'

import LoginLink from '@/components/Auth/LoginLink'

interface LoginButtonProps {
  isVerify?: boolean
  text?: 'Sign in' | 'Log in'
  variant?: ButtonProps['variant']
  href?: string
  width?: StyleProps['width']
}

export default function LoginButton({
  isVerify = false,
  text = 'Sign in',
  variant,
  href,
  width,
}: LoginButtonProps): JSX.Element | null {
  const pathname = usePathname()

  let buttonText: string = text
  if (isVerify) {
    buttonText = 'I verified my email'
  }
  const redirectUrl = href ?? `${pathname}`

  return (
    <LoginLink href={isVerify ? getVerifyUrl(redirectUrl) : redirectUrl} width={width}>
      <Button variant={variant} width={width}>
        {buttonText}
      </Button>
    </LoginLink>
  )
}
